import { render, staticRenderFns } from "./RuleCard.vue?vue&type=template&id=5bc05978&scoped=true"
import script from "./RuleCard.vue?vue&type=script&lang=js"
export * from "./RuleCard.vue?vue&type=script&lang=js"
import style0 from "./RuleCard.vue?vue&type=style&index=0&id=5bc05978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc05978",
  null
  
)

export default component.exports